module.exports = __webpack_public_path__ + "static/media/profile-medium.2b7b0d4e.jpg";